
export default {
  vessel: {
    title: {
      fontSize: '3xl',
      marginBottom: 'md',
      color: 'black'
    },
    subtitle: {
      fontSize: 'xl',
      fontWeight: 'normal',
      marginBottom: 'sm'
    },
    content: {
      fontWeight: 'light',
      color: 'black',
      lineHeight: 'xl',
      marginBottom: {
        all: '0',
        xl: 'md'
      }
    },
    text: {
      $extend: 'content',
      fontWeight: 'normal',
      marginBottom: 0
    }
  },
  computed: {
    items() {
      const items = this.$t('services.points')

      return Object.entries(items).map(([index, text]) => ({
        icon: `/services/point-${index}.svg`,
        alt: text,
        text
      }))
    }
  }
}
